import { mapKeys } from 'lodash-es';

import type { Session } from 'src/shared/session';

export function getAppStatePageStateData({
	session,
	locale,
	countryCode,
}: {
	session?: Session;
	locale: string;
	countryCode: string;
}): unknown {
	return {
		locale,
		countryCode,
		utmParams: session
			? mapKeys(session.trackingData, (_value, key) => key.replace(/_(.)/g, (_m, g: string) => g.toUpperCase()))
			: {},
	};
}
